import { ArrowRight, Mail } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToSection } from "@/components/Nav";

export default function CtaBand() {
  return (
    <section data-testid="cta-band-section" className="bg-navy-deep grain relative py-24 lg:py-32 overflow-hidden">
      <div
        aria-hidden="true"
        className="absolute inset-0 flex items-center justify-center pointer-events-none select-none"
      >
        <span className="font-display font-black text-[22vw] leading-none text-outline whitespace-nowrap">
          VERIFIED
        </span>
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-10">
        <Reveal>
          <h2 className="font-display font-bold text-white text-3xl sm:text-4xl lg:text-6xl tracking-tighter leading-[1.02] mb-8" data-testid="cta-band-heading">
            Need Greater Confidence in Your Patent Data?
          </h2>
          <p className="text-slate-300 text-base md:text-lg leading-relaxed max-w-2xl mb-12">
            Whether you are validating a US patent portfolio, reviewing database records,
            checking critical deadline information, or planning a large-scale IP data quality
            project, Certify IP Global can help you establish a structured validation workflow.
          </p>
          <div className="flex flex-wrap items-center gap-6">
            <button
              data-testid="cta-band-button"
              onClick={() => scrollToSection("#contact")}
              className="inline-flex items-center gap-2 bg-accent text-white font-semibold px-8 py-4 text-sm hover:bg-blue-500 transition-colors duration-300 group"
            >
              Request a Consultation
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
            <a
              href="mailto:info@certifyipglobal.com"
              data-testid="cta-band-email"
              className="inline-flex items-center gap-2.5 text-sm text-slate-300 hover:text-white transition-colors duration-300 group"
            >
              <Mail className="w-4 h-4 text-blue-400" />
              <span className="font-monodata border-b border-transparent group-hover:border-blue-400 transition-colors duration-300">
                info@certifyipglobal.com
              </span>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
